import { Link } from 'react-router-dom';
import './Navbar.css';
import { FaFutbol, FaHome, FaDice, FaChartLine } from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';
import { useTranslation } from 'react-i18next';

export const Navbar: React.FC = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLang);
  };

  return (
    <>
      <nav className="navbar bg-gradient-to-r from-purple-800 to-indigo-900 p-3 shadow-xl backdrop-blur-sm">
        <div className="navbar-container">
          <Link
            to="/"
            className="flex items-center gap-2 py-1 px-2 rounded-lg transition-all hover:bg-white hover:bg-opacity-10"
          >
            <div className="relative">
              <GiMeditation
                className="text-3xl text-teal-300 drop-shadow-md"
                aria-hidden="true"
              />
              <div className="absolute -bottom-1 -right-1 w-2 h-2 bg-teal-300 rounded-full animate-pulse"></div>
            </div>
            <div className="flex flex-col">
              <span className="text-white text-sm font-extrabold tracking-wider sm:hidden">
                BetZen<span className="text-teal-300">.app</span>
              </span>
              <span className="text-white text-xl font-extrabold tracking-wider hidden sm:inline">
                BetZen<span className="text-teal-300">.app</span>
              </span>
              <span className="text-xs text-teal-100 -mt-1 hidden sm:inline-block opacity-90">
                Bet with Peace of Mind
              </span>
            </div>
          </Link>
          <ul className="navbar-menu flex items-center space-x-0 md:space-x-1">
            <li className="navbar-item">
              <Link
                to="/"
                className="text-white hover:text-teal-300 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-opacity-50 rounded-md px-2 py-1.5 flex flex-col items-center bg-purple-900 bg-opacity-30 hover:bg-opacity-50 shadow-md"
              >
                <FaHome className="text-base mb-0.5" />
                <span className="text-[10px] font-medium">Home</span>
              </Link>
            </li>
            <li className="navbar-item">
              <Link
                to="/BetGenerationPage"
                className="text-white hover:text-teal-300 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-opacity-50 rounded-md px-2 py-1.5 flex flex-col items-center bg-purple-900 bg-opacity-30 hover:bg-opacity-50 shadow-md"
              >
                <FaDice className="text-base mb-0.5" />
                <span className="text-[10px] font-medium">BetGen</span>
              </Link>
            </li>
            <li className="navbar-item">
              <Link
                to="/PredictionAccuracyCharts"
                className="text-white hover:text-teal-300 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-opacity-50 rounded-md px-2 py-1.5 flex flex-col items-center bg-purple-900 bg-opacity-30 hover:bg-opacity-50 shadow-md"
              >
                <FaChartLine className="text-base mb-0.5" />
                <span className="text-[10px] font-medium">Accuracy</span>
              </Link>
            </li>
            <li>
              <button
                onClick={toggleLanguage}
                className="text-lg hover:scale-110 transition-transform duration-200 focus:outline-none px-2"
                aria-label={`Switch to ${i18n.language === 'it' ? 'English' : 'Italian'}`}
              >
                {i18n.language === 'it' ? '🇬🇧' : '🇮🇹'}
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};
